import * as Yup from 'yup';

export const validationSchemaBasicDetails = Yup.object().shape({
  sequenceName: Yup.string().required('Sequence Name is required'),

  maxRecipientsPerBatch: Yup.string().required('Max Recipients per Batch is required'),

  scheduledDateTime: Yup.string()
    .required('Schedule At is required')
    .test(
      'is-valid-schedule-time',
      'Schedule date must be at least 15 minutes in the future from current date time',
      (value) => {
        if (!value) return false;
        const selectedDate = new Date(value);
        const now = new Date();
        const minAllowedTime = new Date(now.getTime() + 15 * 60 * 1000);
        return selectedDate > minAllowedTime;
      }
    ),
});
